<div class="grid">

    <div class="col-12">
        <p-card header="Enrollment Report" subheader="" styleClass="ui-card-light" >

            <!--  C R I T E R I A  -->
            <div class="grid">

                <div class="grid col-12 full-width" >
                    <!--  
                    <div class="col-3">
                        <label for="emailAddress" class="margin-right">Receiver's Email: </label>
                        <input type="text"  id="emailAddress"  class="margin-left"  [(ngModel)]="emailAddress" style="width: 50%;">
                      
                    </div>
                    
                    <div class="col-1">
                        <p-button label="Run Report" styleClass="p-button-success wal-success p-button-raised p-button-rounded margin-left" (click)="getPortalEnrollmentStats()"></p-button>
                    
                    </div>
                    -->       
                    <div class="col-1" id="idSpinner" [hidden]="hideSpinner">
                    <div class="loader"></div>  
                    </div>

                </div>


            </div>  


            <!--  G R I D  -->
            
            <div class="grid">
            <div class="col-10" id="idTable">
                <p-table #dt [columns]="cols" [value]="enrollments" selectionMode="single" [(selection)]="selectedBrand"
                class="full-width"  class="p-datatable-striped wal-table"
                    tableStyleClass="prime-table" [showCurrentPageReport]="true" exportFilename="EnrollmentReport" csvSeparator="," [hidden]="hideTable"
                    sortMode="multiple"  [paginator]="true" [rowsPerPageOptions]="[10,15,25,50]" [rows]="15">
                <ng-template pTemplate="caption">
                    Enrollments by Unique Accounts
                </ng-template>
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        @for (col of columns; track col.field) {
                            <th [pSortableColumn]="col.field"
                                [style.display]="col.display"
                                [style.width]="col.width">
                                {{ col.header }}
                                <p-sortIcon [field]="col.field"></p-sortIcon>
                            </th>
                        }                        
                    </tr>
                    <tr>
                        @for (col of columns; track col.field) {
                            <th [style.width]="col.width">
                                @switch (col.field) {
                                    @case ('brandCode') {
                                        <input pInputText type="text" [style.width]="'90%'"
                                            (input)="dt.filter(($any($event.target)).value, col.field, 'contains')"
                                        />
                                    }
                                    @case ('brandDescription') {
                                        <input pInputText type="text" [style.width]="'90%'"
                                            (input)="dt.filter(($any($event.target)).value, col.field, 'contains')"
                                        />
                                    }
                                    @case ('passName') {
                                        <input pInputText type="text" [style.width]="'90%'"
                                            (input)="dt.filter(($any($event.target)).value, col.field, 'contains')"
                                        />
                                    }
                                    @default {
                                    }
                                }
                            </th>
                        }

                    </tr>  
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns">
                    <tr [pSelectableRow]="rowData">
                        @for (col of columns; track col.field) {
                            <td [style.width]="col.width" [style.display]="col.display">
                                {{ rowData[col.field] }}
                            </td>
                        }
                    </tr>
                </ng-template>
                    <ng-template pTemplate="footer">
                        <tr>
                            <td></td>
                            <td></td>
                            <td style="background-color:#7B95A3; color: white">TOTALS:</td>
                            <td style="background-color:#7B95A3; color: white">{{totalUniqueAccounts}}</td>
                            <td style="background-color:#7B95A3; color: white">{{totalLast30AddsCnt}}</td>
                            <td style="background-color:#7B95A3; color: white">{{totalLast30Removes}}</td>
                            <td style="background-color:#7B95A3; color: white">{{totalLast30Nets}}</td>
                        </tr>
                    </ng-template>    
                    <ng-template pTemplate="summary">
                        <div style="text-align:left">
                            <div class="ui-helper-clearfix">
        <!-- 
                                <button type="button" pButton icon="fa-file-o" iconPos="left"
                                label="CSV Export" (click)="dt.exportCSV()" style="float:right"></button>
                                -->
                                <p-button type="button" label="CSV Export" 
                                    styleClass="p-button-info wal-info p-button-raised p-button-rounded margin-left" (click)="dt.exportCSV()">
                                </p-button>

                            </div>
                        </div>
                    </ng-template>    
                </p-table>
            </div>

            </div>

           
        </p-card>
    </div>            

</div>    


<p-confirmDialog class="lf-confirm-dialog" appendTo="body" key="enrollment-artifact"></p-confirmDialog>